import { BaseBus } from "./BaseBus";

export class BidsheetEquipmentBus extends BaseBus{
      constructor(busObj: BidsheetEquipmentBus = null) {
            super(busObj)
      }
      CID(): any {
            return this.bidRefrigerantEquipmentsId;
        }
        
       bidRefrigerantEquipmentsId: string;
      // description: string;
      // material: number;
      // labor: number;
      // refrigerant: number;
      // insertDt: Date;
      // insertUserId: string;
      // updateDt: Date;
      // updateUserId: any;
      // isActive: boolean;
      // sortOrder: number;
      quantity: number;
}